import { type ECommerceOrderType } from '@hooks-api/types/dataModel/eCommercePayments'
import { createContext, useMemo, type PropsWithChildren } from 'react'
export interface CheckoutProviderProps {
  orderType: ECommerceOrderType
  campaignId: number
  campaignCode: string
  currency?: string
  setIsCreditCardValid?: (isValid: boolean) => void
}

export const CheckoutContext = createContext<CheckoutProviderProps | null>(null)

export const CheckoutProvider = (props: PropsWithChildren<CheckoutProviderProps>) => {
  const { children, orderType, currency, campaignId, campaignCode, setIsCreditCardValid } = props

  const contextValue = useMemo(() => ({
    orderType,
    currency,
    campaignId,
    campaignCode,
    setIsCreditCardValid,
  }), [campaignCode, campaignId, currency, orderType, setIsCreditCardValid])

  return (
    <CheckoutContext.Provider value={contextValue}>
      {children}
    </CheckoutContext.Provider>
  )
}
